import { Slider } from './Slider';
import type { SliderTypes } from './Slider';

export { Slider };
export type { SliderTypes };
